// extracted by mini-css-extract-plugin
export default {"imageWrapper":"vL-z","twoColumnImage":"wL-z"};